import { InlineMarkdown } from '@/components/core/markdown/markdown';
import { hasMath } from '@/lib/mindmap-markdown';
import { cn } from '@/lib/utils';

/**
 * A mindmap label. One with maths (`$..$`) renders it with KaTeX, at the
 * surrounding text size (KaTeX defaults to 1.21em, wider than `measurePill`
 * reserved). A plain label stays plain text: as markdown, "1. Intro" would
 * become a list.
 */
export function MindmapLabel({
  label,
  className,
}: {
  label: string;
  className?: string;
}) {
  if (!hasMath(label)) return <span className={className}>{label}</span>;
  return (
    <InlineMarkdown className={cn('[&_.katex]:text-[1em]', className)}>
      {label}
    </InlineMarkdown>
  );
}
